import script from "./MaterialIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./MaterialIcon.vue?vue&type=script&lang=ts&setup=true"

import "./MaterialIcon.vue?vue&type=style&index=0&id=8259ad62&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8259ad62"]])

export default __exports__